import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatLabel } from '@angular/material/input';
import { Router } from '@angular/router';
import { NavBarService } from '../../services/nav-bar.service';
import { NetworkService } from '../../services/network-service.service';
import { LocalDatabaseService } from '../../services/local-database.service';

@Component({
  selector: 'app-footer-bar',
  standalone: true,
  imports: [MatIconModule, MatLabel, MatButtonModule],
  templateUrl: './footer-bar.component.html',
  styleUrl: './footer-bar.component.scss',
})
export class FooterBarComponent {
  private readonly networkService = inject(NetworkService);
  private readonly databaseSrv = inject(LocalDatabaseService);

  public netStatus: boolean = false;
  public hideNavRoutes: string[] = ['/login']; // Rutas donde se oculta el footer

  private readonly baseMenu = [
    { label: 'Inicio', icon: 'home', url: 'inicio' },
    { label: 'Asist.', icon: 'support_agent', url: 'asistencia' },
    { label: 'Acerca de', icon: 'quick_reference', url: 'about' },
    { label: 'Siniestros', icon: 'car_crash', url: 'siniestros' },
    { label: 'Perfil', icon: 'account_circle', url: 'perfil' },
  ];

  public menu = [...this.baseMenu];
  public readonly isOnline = this.networkService.isOnline;

  constructor(private router: Router, private navState: NavBarService) {}

  ngOnInit() {
    this.networkService.online$.subscribe((isOnline) => {
      this.netStatus = isOnline;
      if (isOnline) {
        this.menu = [...this.baseMenu];
      } else {
        this.menu = this.baseMenu.map((item) => {
          if (item.label === 'Inicio')
            return { label: 'Login', icon: 'login', url: 'login' };
          if (item.label === 'Asist.')
            return { label: 'Documentacion', icon: 'wallet', url: 'docs' };
          return item;
        });
      }
    });
  }

  async navigate(ruta: string) {
    try {
      // Obtener el usuario actual logueado desde IndexedDB
      const currentUser = await this.databaseSrv.getCurrentLoggedUser();
      
      if (currentUser) {
        // Si hay usuario logueado, navegamos con el state
        this.router.navigate([ruta], {
          state: {
            user: currentUser
          }
        });
      } else {
        // Si no hay usuario logueado, navegar sin state (para rutas que no requieren auth)
        this.router.navigate([ruta]);
      }
    } catch (error) {
      console.error('Error obteniendo usuario para navegación:', error);
      // En caso de error, intentar navegar sin state
      this.router.navigate([ruta]);
    }
  }
}
